import React from "react";
import SortableIndicator from "./SortableIndicator/SortableIndicator";

export default function ColumnValue({column}) {
    return <>
        {column.render('Header')}
        <SortableIndicator column={column}/>
    </>
}